import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useMutation } from "@apollo/client";
import { saveCustomerPushSubscriptionMutation } from "@src/util/mutation/dutyRequest.mutation";

const VAPID_PUBLIC_KEY = "BNdYP56lkxXX5QK5-wUupFLa7gFnHwCUs4vNUqzHEq22K6Yiss044K6OM8Nllna4ROJsgb8V-dbZwL2UWTouij0";

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = window.atob(base64);
    return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

export const PrivateRoutes = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem('authToken');
    const { pathname } = useLocation();

    const [savePushSubscription] = useMutation(saveCustomerPushSubscriptionMutation);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!localStorage.getItem('authToken')) {
                if (pathname !== "/") window.location = "/";
            }
        }, 2000);
        setLoading(false);
        return () => clearInterval(interval);
    }, []);

    // Register SW and subscribe to web push on login
    useEffect(() => {
        if (!token || !('serviceWorker' in navigator) || !('PushManager' in window)) return;

        (async () => {
            try {
                const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
                await navigator.serviceWorker.ready;

                const permission = Notification.permission === 'granted'
                    ? 'granted'
                    : await Notification.requestPermission();

                if (permission !== 'granted') return;

                let sub = await reg.pushManager.getSubscription();
                if (!sub) {
                    sub = await reg.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
                    });
                }

                await savePushSubscription({ variables: { subscription: JSON.stringify(sub) } });
            } catch (err) {
                console.error('[customer-push]', err);
            }
        })();
    }, [token]);

    const renderChildrenWithProps = () => {
        return React.Children.map(children, (child) => {
            if (React.isValidElement(child)) return React.cloneElement(child, {});
            return child;
        });
    };

    return loading || !token
        ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Spin />
            </div>
        )
        : <>{renderChildrenWithProps()}</>;
};
